module.exports = __webpack_public_path__ + "static/img/stay-option-icon-pool.f0aeb1d4.svg";